<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-tab-pane v-for="(item,type) in typeArr" :name="type" :label="item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8">
                <CommonExcel ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
              </el-row>
            </div>
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%">
              <el-table-column label="序号" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template slot-scope="{row,$index}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig(type)">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="提示" :visible.sync="dialog" width="80%">
        <el-table size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <el-table-column prop="lv" label="等级">
            <template slot-scope="scope">
              <span>{{ scope.row.lv }}</span>
            </template>
          </el-table-column>
          <el-table-column v-for="(item, index) in weightNumber" :key="index" :label="'权重'+item">
            <template slot-scope="scope">
              <span>{{ scope.row.weight[index].num }}</span>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer"><el-button @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import {
  saveRunFotItBaseConf
} from '@/api/config/run-for-it-cfg'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { actionComAuxiliary, comAuxiliary, delComAuxiliary } from '@/api/config/activity-auxiliary-cfg'

export default {
  name: 'RandMoney',
  components: { CommonExcel },
  props: {
    curClass: {
      type: String,
      default: 'randMoney'
    },
    title: {
      type: String,
      default: '随机金币配置'
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      diaLogList: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 20
      },
      total: 0,
      list: [],
      type: 1,
      typeArr: { 1: this.title },
      baseList: [],
      mapDialog: false,
      mapDialogList: [],
      groupsList: [],
      weightNumber: [],
      weightData: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
      this.initBase()
    },
    initBase() {},
    openDialog(config) {
      this.dialog = true
      this.diaLogList = config
      this.weightNumber = []
      if (!this.diaLogList) {
        this.diaLogList = []
        return
      }
      if (this.diaLogList.length > 0) {
        const len = this.diaLogList[0].weight.length
        for (let i = 0; i < len; i++) {
          this.weightNumber[i] = this.diaLogList[0].weight[i].v
        }
      }
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    handleSaveBase() {
      saveRunFotItBaseConf({ data: JSON.stringify(this.baseList) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const list = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[3], revive: this.list[4] }, true, 'name', 'id')
        for (let i = 0; i < list.length; i++) {
          list[i].mapWeight = this.$refs.CommonExcelRef.tranToTarget(list[i].mapWeight, { id: this.list[2] }, true, 'name', 'id')
        }
        this.baseList = list
        this.handleSaveBase()
        break
      }
    },
    exportBaseCfg() {
      const fileName = '随机金币配置'
      const hearer = []
      const excelData = []
      const name = ['随机金币配置']
      hearer.push([])
      excelData.push([])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    getList() {
      this.loading = true
      comAuxiliary({ class: this.curClass, select: 0 }).then(res => {
        this.loading = false
        this.list = res.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
      })
    },
    handleDel(index, id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id == 0) {
          this.list[this.type].splice(index, 1)
        } else {
          delComAuxiliary({ idList: [id] }).then(res => {
            this.list[this.type].splice(index, 1)
          })
        }
      })
    },
    handleAdd(type, name, config) {
      if (!this.list) {
        this.list = {}
        this.list[1] = []
      }
      this.list[type].push({ id: 0, class: this.curClass, type: type, name: name, types: this.type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name == sheet) {
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      actionComAuxiliary({ class: this.curClass, list: this.list }).then(res => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = '随机金币配置'
      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef[0].makeExcelData(dataArr[i], { lv: '等级', weight: { name: '权重', sub: { v: '权重', num: '数量' }}})
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addBaseConfig() {
      this.baseList.push({ groupIds: [], mapWeight: [], rewardId: 0, revive: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    addMapDialogList() {
      this.mapDialogList.push({ v: 0, speed: 0, distance: 6, id: 0 })
    },
    deleteMapDialogList(index) {
      this.mapDialogList.splice(index, 1)
    },
    handleEditMapWeight(config) {
      this.mapDialog = true
      this.mapDialogList = config
    },
    handleGetMapName(id) {
      for (let i = 0; i < this.list[2].length; i++) {
        if (this.list[2][i].id === id) {
          return this.list[2][i].name
        }
      }
      return ''
    },
    handleMapWeight(data) {
      let str = ''
      for (let i = 0; i < data.length; i++) {
        str += '权重：' + data[i].v + '，地图：' + this.handleGetMapName(data[i].id) + '\n'
      }
      return str
    },
    handleDownLoadJson() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/makeParkourJson')
    },
    addRewardDialogList() {
      if (this.type == 3) {
        this.diaLogList.push({ v: 0, reward: [] })
      } else if (this.type == 4) {
        this.diaLogList.push({ mtype: 1, bet: 1, sku: '', price: 0, coin: 'money1' })
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    }
  }
}
</script>

